// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let QuestionResponse
require("./styles/question-response.css")

export default QuestionResponse = (function () {
  QuestionResponse = class QuestionResponse extends (
    require("lib/static-shim").default(
      require("lib/uniform/views/form").default
    )
  ) {
    static initClass() {
      this.prototype.events = {
        "click .reset-assessment-response a": "resetAssessmentResponse"
      }
    }

    resetAssessmentResponse() {
      this.model.set({ is_answered: false })
      for (let op of Array.from(this.question.get("options"))) {
        op.selected_status = null
        op.disabled = false
      }
      return this.triggerMethod("answer:reset")
    }

    constructor(options) {
      if (options == null) {
        options = {}
      }
      super(...arguments)
      ;({
        question: this.question,
        assessment: this.assessment,
        isReview: this.isReview
      } = options)
      if (!this.question && !this.assessment) {
        throw new Error(
          "QuestionResponse requires question and assessment options."
        )
      }

      this._transitionAfterAnswer = this._shouldShowFeedback()
      this.listenTo(this.model, "sync", function () {
        return this.triggerMethod("answer:saved")
      })
    }

    onAfterFormInit() {
      if (this._transitionAfterAnswer) {
        this.transitionAnswerSaved()
        this._transitionAfterAnswer = false
      }
      return this.triggerMethod("after:on:render")
    }

    onAnswerSaved() {
      this.assessment.answers.add(this.model)
      this.render()
      return (this._transitionAfterAnswer = true)
    }

    transitionAnswerSaved() {}
    // override in subview

    showSuccessMessage() {} //nope

    serializeData() {
      const data = super.serializeData()
      data.question = this.question.toJSON()
      if (data.is_answered) {
        data.modified = moment(data.modified).local()
        data.disabled = true
      }
      if (this.isReview) {
        data.disabled = true
      }
      data.is_practice = this.assessment.get("assessment_type") === 1
      data.is_content_completed = this.assessment.get("is_content_completed")
      return data
    }

    _shouldShowFeedback() {
      return (
        this.model.get("is_answered") && this.assessment.showRealtimeFeedback()
      )
    }
  }
  QuestionResponse.initClass()
  return QuestionResponse
})()
